import { render, staticRenderFns } from "./OldSignup.vue?vue&type=template&id=5bbc1fa4&scoped=true&"
import script from "./OldSignup.vue?vue&type=script&lang=js&"
export * from "./OldSignup.vue?vue&type=script&lang=js&"
import style0 from "./OldSignup.vue?vue&type=style&index=0&id=5bbc1fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc1fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbc1fa4')) {
      api.createRecord('5bbc1fa4', component.options)
    } else {
      api.reload('5bbc1fa4', component.options)
    }
    module.hot.accept("./OldSignup.vue?vue&type=template&id=5bbc1fa4&scoped=true&", function () {
      api.rerender('5bbc1fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/pages/Signup/OldSignup.vue"
export default component.exports